import AppDrawer from "../../../components/Drawers/AppDrawer";
import AppSpinner from "../../../elements/AppSpinner";
import { Button } from "reactstrap";
import RelatedRecordsDrawerBody from "./RelatedRecordsDrawerBody";
import { RelatedRecord } from "../../../types/GlobalInterfaces";
import { Module } from "../../../types/TenantInterfaces";

interface RelatedRecordsDrawerInterface {
  open: boolean;
  handleClose: any;
  handleSave: any;
  updatingCloud: boolean;
  remainingModuleOptions: Module[];
  existingRelatedRecord?: RelatedRecord;
  setExistingRelatedRecord: any;
}

const RelatedRecordsDrawer = ({
  open,
  handleClose,
  handleSave,
  updatingCloud,
  remainingModuleOptions,
  existingRelatedRecord = undefined,
  setExistingRelatedRecord,
}: RelatedRecordsDrawerInterface) => {
  return (
    <AppDrawer
      open={open}
      onClose={handleClose}
      headerTitle="Cloud Defaults"
      headerDescription="Set default values and records related to the Cloud"
      headerOptions={
        <Button
          size="sm"
          color="primary"
          onClick={() => handleSave(existingRelatedRecord)}
          style={{ width: 80 }}
          disabled={updatingCloud}
        >
          {updatingCloud ? <AppSpinner size="sm" color="white" /> : "Save"}
        </Button>
      }
      body={
        <RelatedRecordsDrawerBody
          existingRelatedRecord={existingRelatedRecord}
          setExistingRelatedRecord={setExistingRelatedRecord}
          remainingModuleOptions={remainingModuleOptions}
        />
      }
    />
  );
};

export default RelatedRecordsDrawer;
